import { setAlert } from 'src/redux/slices/snackbar';
import { useDispatch } from 'src/redux/store';
import type { ALERT } from 'src/types/enum';

export const useAlert = () => {
  const dispatch = useDispatch();

  const showAlert = (type: ALERT, translatedMessage: string) => {
    dispatch(
      setAlert({
        type,
        msg: translatedMessage
      })
    );
  };

  return {
    showAlert
  };
};
